<script setup>
import { useI18n } from 'vue-i18n';

import { HomeRenewCertificate, HomeCadesSignature } from '@components/home';
import { XCardInteractive } from '@clicksign/excalibur';
import { sendEvent } from '@utils/analytics';

const { t } = useI18n();

function documentResultPage() {
  window.location.href = '/validators';
}

function accessTermPage() {
  window.location.href = '/validate_accesses/new';
}

function validatePasswordPage() {
  window.location.href = '/validate_accesses';
}

function renewCertificatePage() {
  window.location.href = '/renew_certificates';
}

function cadesSignaturePage() {
  sendEvent({
    eventCategory: 'document-validator',
    eventAction: 'button-download-p7s-click',
  });
  window.location.href = '/cades_signature';
}
</script>

<template>
  <div
    id="home"
    :class="$style.homePage"
  >
    <h1 :class="$style.title">
      {{ t('home.title') }}
    </h1>

    <div :class="$style.container">
      <XCardInteractive
        :title="t('home.validate_with_document.title')"
        :cta-text="t('home.validate_with_document.button')"
        icon="file-lines"
        size="large"
        @click="documentResultPage"
      >
        {{ t('home.validate_with_document.description') }}
      </XCardInteractive>

      <XCardInteractive
        :title="t('home.generate_password.title')"
        :cta-text="t('home.generate_password.button')"
        icon="file-certificate"
        size="large"
        @click="accessTermPage"
      >
        {{ t('home.generate_password.description') }}
      </XCardInteractive>

      <XCardInteractive
        :title="t('home.validate_with_password.title')"
        :cta-text="t('home.validate_with_password.button')"
        icon="key"
        size="large"
        @click="validatePasswordPage"
      >
        {{ t('home.validate_with_password.description') }}
      </XCardInteractive>
    </div>

    <HomeRenewCertificate @click="renewCertificatePage()" />

    <HomeCadesSignature
      :class="$style.documentP7SContainer"
      @click="cadesSignaturePage()"
    />
  </div>
</template>

<style lang="scss" module>
.homePage {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding-bottom: var(--space-large-xx);
  gap: var(--space-large);

  .title {
    font-size: var(--font-size-large-xxx);
    text-align: center;
  }

  .container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    max-width: 960px;
    gap: var(--space-medium);
  }
}
</style>
